import { usePointCloudContext } from 'features/pointClouds'
import React, { FC, useState } from 'react'
import styled from 'styled-components'

import { LayersMenu } from './LayersMenu'
import { OpenLayersButton } from './OpenLayersButton'

const SectionContainer = styled.div<{ $menuOpen: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: end;
  width: ${({ $menuOpen }) => ($menuOpen ? '180px' : '56px')};
  transition: width 500ms;
  overflow: hidden;
`

export const Layers: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { showPointCloud, setShowPointCloud, showTiles, setShowTiles } =
    usePointCloudContext()

  function handleLayerSelect(layer: 'map' | 'point') {
    switch (layer) {
      case 'point':
        setShowPointCloud(!showPointCloud)
        break
      case 'map':
        setShowTiles(!showTiles)
        break
      default:
        break
    }
  }

  const selectedLayers = []

  if (showPointCloud) selectedLayers.push('point')
  if (showTiles) selectedLayers.push('map')
  return (
    <SectionContainer $menuOpen={isMenuOpen}>
      <LayersMenu
        isOpen={isMenuOpen}
        setIsOpen={setIsMenuOpen}
        onLayerSelect={handleLayerSelect}
        selectedLayers={selectedLayers}
      />
      <OpenLayersButton isSelected={isMenuOpen} setIsSelected={setIsMenuOpen} />
    </SectionContainer>
  )
}
